<template>
<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <PermissionForm v-if="permission" :permission="permission" />
    <LoadingPage v-if="!permission"/>
  </PageRowWrapper>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import PermissionForm from '@/components/settings/users/permission/PermissionForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'PermissionEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    PermissionForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      permission: state => state.permission.permissionById
    })
  },
  methods: {
    ...mapActions('permission', ['fetchById', 'cleanState'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
